import React, { useEffect, useState } from 'react';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { business, navLinks } from '../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full border-b transition-colors duration-200 ease-out ${scrolled ? 'border-white/10 bg-ink/95 backdrop-blur' : 'border-transparent bg-ink'}`} data-id="element-93" data-mp="2wkgso64wdexr">
      <div className="mx-auto flex h-[72px] max-w-shell items-center gap-6 px-5 lg:h-[84px] lg:px-8" data-id="element-94" data-mp="36aij34kq39fu">
        <a href="#top" className="flex shrink-0 items-center" data-id="element-95" data-mp="3bbzggq400dro">
          <span className="flex h-[66px] w-[66px] items-center justify-center overflow-hidden lg:h-[78px] lg:w-[78px]" data-id="element-96" data-mp="3faykm8hwo6i2">
            <img src={business.logoUrl} alt={`${business.name} logo`} className="h-full w-auto max-w-none" data-id="element-97" data-mp="2wlmbrn1xqko4" />
          </span>
          <span className="sr-only" data-id="element-98" data-mp="2mlvg3i1n1zmg">{business.name}</span>
        </a>

        <nav aria-label="Primary" className="ml-auto hidden items-center gap-7 lg:flex" data-id="element-99" data-mp="2hnlkj6c04x0b">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-[13px] font-semibold uppercase tracking-[0.08em] text-chalk/70 transition-colors duration-150 ease-out hover:text-white" data-id="element-100" data-mp="3fasx7hu45qdm">
              {link.label}
            </a>)}
        </nav>

        <div className="ml-auto flex items-center gap-3 lg:ml-0" data-id="element-101" data-mp="30m684oeopk97">
          <a href="#request" className="hidden rounded-md border border-white/20 px-4 py-2.5 text-[13px] font-semibold text-white transition-colors duration-150 ease-out hover:border-white/50 md:inline-flex" data-id="element-102" data-mp="1xhctr0mgpvf">
            Request Appointment
          </a>
          <a href={business.phoneHref} className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-brand px-4 py-2.5 text-[13px] font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light lg:px-5" data-id="element-103" data-mp="1wcxp0xeakgzz">
            <PhoneIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-104" data-mp="18n3fopt6lakh" />
            <span className="hidden sm:inline" data-id="element-105" data-mp="18p6bxrkxfzxn">Call {business.phone}</span>
            <span className="sm:hidden" data-id="element-106" data-mp="1cpgknc03t4g7">Call Now</span>
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-white/15 text-white lg:hidden" data-id="element-107" data-mp="ypfjrwju9x0q">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-108" data-mp="meeoi634ggrv" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-109" data-mp="mcbtf7n43xga" />}
          </button>
        </div>
      </div>

      {open && <div id="mobile-nav" className="border-t border-white/10 bg-ink px-5 pb-6 pt-2 lg:hidden" data-id="element-110" data-mp="w4pxw85kri65">
          <nav aria-label="Mobile" className="flex flex-col" data-id="element-111" data-mp="rc6eguk7hstf">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="border-b border-white/5 py-3.5 text-sm font-semibold uppercase tracking-[0.08em] text-chalk/80" data-id="element-112" data-mp="153ba7lkge0yh">
                {link.label}
              </a>)}
            <a href="#request" onClick={() => setOpen(false)} className="mt-5 rounded-md border border-white/20 py-3 text-center text-sm font-semibold text-white" data-id="element-113" data-mp="3gup000zxux0u">
              Request Appointment
            </a>
          </nav>
        </div>}
    </header>;
}